import type { ReceiptAttachment } from "./types";

export function isInlineReceiptImage(path: string): boolean {
  return path.startsWith("data:") || path.startsWith("blob:");
}

export async function resolveReceiptImageUrls(
  receipts: ReceiptAttachment[],
  signStoragePath: (path: string) => Promise<string | null>,
): Promise<Record<string, string>> {
  const resolvedEntries = await Promise.all(
    receipts.map(
      async (
        receipt,
      ): Promise<readonly [string, string] | null> => {
        const path = receipt.storagePath.trim();
        if (!path) return null;
        if (isInlineReceiptImage(path)) return [receipt.id, path] as const;
        const signedUrl = await signStoragePath(path);
        return signedUrl ? ([receipt.id, signedUrl] as const) : null;
      },
    ),
  );

  return Object.fromEntries(
    resolvedEntries.filter(
      (entry): entry is readonly [string, string] => entry !== null,
    ),
  );
}
